import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {dropdownEvent} from "./inputEvents";
import {UnLitElement} from "../../../common/elements";

@customElement("eop-dropdown-option")
export class EopDropdownOption extends UnLitElement {

    @property()
    public value: string;
    @property()
    public label: string;
    @property({attribute: true, type: Boolean})
    public selected: boolean = false;

    public render(): TemplateResult {
        return html`
            <div @click=${this.sendSelectEvent} class="custom-option">${this.label}</div>`;
    }

    private sendSelectEvent(event: Event): void {
        event.stopPropagation();
        this.dispatchEvent(dropdownEvent(this.value, this.label));
    }
}